import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const workspaceTimeZonesNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("workspace-time-zones-nro-heading", "Workspace Time Zones"),
  pageNameForTracking: () => "Workspace Time Zones",
  getDeveloperNavigationAllowed: ({ hasPermission }) => {
    return hasPermission("company", {
      permission: "admin",
    });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/admin_settings/workspace_time_zones/:appGroupId",
};
